import { jsx as o } from "react/jsx-runtime";
import { createContext as m, useContext as g } from "react";
import { ThemeProvider as h, useTheme as l } from "./ThemeContext.js";
import { LanguageProvider as d, useLanguage as x } from "./LanguageContext.js";
const i = m(null);
function I(n) {
  const {
    chat: t,
    language: r,
    languageResources: e,
    theme: s,
    colors: u,
    children: a
  } = n, c = { chat: t };
  return /* @__PURE__ */ o(d, { language: r, languageResources: e, children: /* @__PURE__ */ o(h, { theme: s, colors: u, children: /* @__PURE__ */ o(i.Provider, { value: c, children: a }) }) });
}
const K = (...n) => {
  const t = x(), r = l(), e = g(i);
  if (!e)
    throw new Error("useUIKit must be used within a UIKitProvider");
  return {
    ...r,
    ...t,
    ...e
  };
};
export {
  I as UIKitProvider,
  K as useUIKit
};
